module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/folder-09e1f.png";